module.exports = __webpack_public_path__ + "kshitij-desk.9848736addf5855cb0bf95c9bb0e0be1.webp";